import { useState } from 'react';
import { useResizeObserver } from './use-resize-observer';
import { useDesignContext } from '../../design-provider';
var clientWindow = true ? window : undefined;
export function useMobile() {
  var _a;
  var _useDesignContext = useDesignContext(),
    initializeBreakpoint = _useDesignContext.initializeBreakpoint;
  var containerQuery = (_a = clientWindow === null || clientWindow === void 0 ? void 0 : clientWindow.document.getElementById('container-query')) !== null && _a !== void 0 ? _a : clientWindow === null || clientWindow === void 0 ? void 0 : clientWindow.document.body;
  // 设定初始值，防止 nextjs hydration 失败
  var _useState = useState(function () {
      return initializeBreakpoint !== 'pc';
    }),
    mobile = _useState[0],
    setMobile = _useState[1];
  useResizeObserver(function (_ref) {
    var width = _ref.width;
    return setMobile(width < 1024);
  }, containerQuery);
  return mobile;
}